export default "__VITE_ASSET__a38510ab__"